import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IThirdPartyConfig, defaultValue } from 'app/shared/model/third-party-config.model';

export const ACTION_TYPES = {
  FETCH_THIRDPARTYCONFIG_LIST: 'thirdPartyConfig/FETCH_THIRDPARTYCONFIG_LIST',
  FETCH_THIRDPARTYCONFIG: 'thirdPartyConfig/FETCH_THIRDPARTYCONFIG',
  CREATE_THIRDPARTYCONFIG: 'thirdPartyConfig/CREATE_THIRDPARTYCONFIG',
  UPDATE_THIRDPARTYCONFIG: 'thirdPartyConfig/UPDATE_THIRDPARTYCONFIG',
  DELETE_THIRDPARTYCONFIG: 'thirdPartyConfig/DELETE_THIRDPARTYCONFIG',
  RESET: 'thirdPartyConfig/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IThirdPartyConfig>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type ThirdPartyConfigState = Readonly<typeof initialState>;

// Reducer

export default (state: ThirdPartyConfigState = initialState, action): ThirdPartyConfigState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_THIRDPARTYCONFIG_LIST):
    case REQUEST(ACTION_TYPES.FETCH_THIRDPARTYCONFIG):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_THIRDPARTYCONFIG):
    case REQUEST(ACTION_TYPES.UPDATE_THIRDPARTYCONFIG):
    case REQUEST(ACTION_TYPES.DELETE_THIRDPARTYCONFIG):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_THIRDPARTYCONFIG_LIST):
    case FAILURE(ACTION_TYPES.FETCH_THIRDPARTYCONFIG):
    case FAILURE(ACTION_TYPES.CREATE_THIRDPARTYCONFIG):
    case FAILURE(ACTION_TYPES.UPDATE_THIRDPARTYCONFIG):
    case FAILURE(ACTION_TYPES.DELETE_THIRDPARTYCONFIG):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_THIRDPARTYCONFIG_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_THIRDPARTYCONFIG):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_THIRDPARTYCONFIG):
    case SUCCESS(ACTION_TYPES.UPDATE_THIRDPARTYCONFIG):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_THIRDPARTYCONFIG):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/third-party-configs';

// Actions

export const getEntities: ICrudGetAllAction<IThirdPartyConfig> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_THIRDPARTYCONFIG_LIST,
  payload: axios.get<IThirdPartyConfig>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IThirdPartyConfig> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_THIRDPARTYCONFIG,
    payload: axios.get<IThirdPartyConfig>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IThirdPartyConfig> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_THIRDPARTYCONFIG,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IThirdPartyConfig> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_THIRDPARTYCONFIG,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IThirdPartyConfig> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_THIRDPARTYCONFIG,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
